import { computed, inject, InjectionToken, Signal } from '@angular/core';
import {
  KioskGlobalSettings,
  UIKioskGlobalSettings,
} from '@core/models/kiosk-global-settings.model';

const KioskGlobalSettingsToken = new InjectionToken<Signal<KioskGlobalSettings>>(
  'Expose Kiosk Global Settings, it is provided at kiosk main layout level and accessible for all descendants',
);

export function injectKioskGlobalSettings() {
  const kioskGlobalSettings = inject(KioskGlobalSettingsToken, {
    optional: true,
  });
  const kioskGlobalSettingsWithDefaultValues = computed(() => {
    const productCardChoice = kioskGlobalSettings?.()?.productCard?.choice ?? 1; // Default choice is 1
    return {
      stepperProductComposition: {
        autoAddToCart: kioskGlobalSettings?.()?.stepperProductComposition.autoAddToCart ?? false,
        hideNextButtonIfTheRequiredQuantityIsOne:
          kioskGlobalSettings?.()?.stepperProductComposition
            .hideNextButtonIfTheRequiredQuantityIsOne ?? false,
      },
      productCard: {
        choice: productCardChoice,
        cardColSpan: [4, 6].includes(productCardChoice) ? 2 : 1,
        styles: {
          type: kioskGlobalSettings?.()?.productCard?.styles?.type ?? 'defaultCard',
        },
      },
    } satisfies UIKioskGlobalSettings;
  });
  return kioskGlobalSettingsWithDefaultValues;
}

export function provideKioskGlobalSettingsToken(
  kioskGlobalSettings: () => Signal<Partial<KioskGlobalSettings> | undefined>,
) {
  return {
    provide: KioskGlobalSettingsToken,
    useFactory: kioskGlobalSettings,
  };
}
